import type { PlaceholderTextPluginOptions } from '@atlaskit/editor-plugin-placeholder-text/placeholder-text-plugin-type';

interface Props {
	options: never;
}

export function placeholderTextPluginOptions({}: Props): PlaceholderTextPluginOptions {
	return {};
}
